import { notification } from 'antd';
import type { ArgsProps } from 'antd/es/notification';
import './notification.css';
import { appAlertIcons } from '../alert.utils';

const METHODS = ['success', 'info', 'warning', 'error'] as const;

METHODS.forEach((method) => {
  const original = notification[method];

  notification[method] = ((args: ArgsProps) => {
    const enhancedIcon = appAlertIcons[method];

    return original({
      className: 'calilio-notification',
      icon: enhancedIcon,
      placement: 'top',
      duration: 5,
      ...args,
    });
  }) as (typeof notification)[typeof method];
});
